module.exports = __webpack_public_path__ + "static/media/node-js.18132237.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/node-js.png
// module id = 616
// module chunks = 146